import StatusSuccessful from './variations/StatusSuccessful';
import StatusFailed from './variations/StatusFailed';
import StatusInProgress from './variations/StatusInProgress';
import StatusWarning from './variations/StatusWarning';
import StatusCanceled from './variations/StatusCanceled';
import Status from './Status';

export { Status, StatusSuccessful, StatusFailed, StatusInProgress, StatusWarning, StatusCanceled };
